import baseStyles from "../../toolbox.module.css";
import { useState } from "react";
import styles from "./toolbox-poster-size.module.css";
import { PosterSizePreset } from "PosterEditor/model/poster-project";
import { Toolbox, BasicToolboxProps } from "../../toolbox";
import { ToolboxComponentPosterSizeIcon } from "../../toolbox-components/toolbox-component-poster-size-icon";
import { ToolboxComponentToggle } from "../../toolbox-components/toolbox-component-toggle";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";
import { useEditorUI } from "PosterEditor/use-editor-ui";
import {
  AvailableSizePresets,
  AvailableUnitMeasurements,
} from "PosterEditor/model/poster-project";

interface ToolboxPosterSizeProps extends BasicToolboxProps {}

export const ToolboxPosterSize = (props: ToolboxPosterSizeProps) => {
  const { project, setMapSize } = usePosterProject();
  const { editorUIState, setUnitMeasurement } = useEditorUI();
  const units = AvailableUnitMeasurements.map((unit) => unit);

  return (
    <Toolbox
      title="Size"
      collapsible={props.collapsible}
      isCollapsed={props.isCollapsed}
      onToggleCollapse={props.onToggleCollapse}
    >
      <div className={baseStyles.paddedBodyContent}>
        <div className={styles.container}>
          <ToolboxComponentToggle
            optionTitles={AvailableUnitMeasurements.map((unit) => unit)}
            selectedOptionIndex={units.findIndex(
              (unit) => unit === editorUIState.unitMeasurement
            )}
            onClickOption={(optionIndex) => {
              setUnitMeasurement(units[optionIndex]);
            }}
          />
          <SizeGrid
            presets={[project.size]}
            onClick={(preset) => {
              setMapSize(preset);
            }}
          />
        </div>
      </div>
    </Toolbox>
  );
};

interface SizeGridProps {
  presets: PosterSizePreset[];
  onClick: (preset: PosterSizePreset) => void;
}

export const SizeGrid = (props: SizeGridProps) => {
  return (
    <div className={styles.gridContainer}>
      {AvailableSizePresets.map((preset) => (
        <ToolboxComponentPosterSizeIcon
          key={preset}
          preset={preset}
          isSelected={props.presets.includes(preset)}
          onClick={() => {
            props.onClick(preset);
          }}
        />
      ))}
    </div>
  );
};
